import React from "react";
import { motion } from "framer-motion";
import { VISIT_DEFINITION } from "@/lib/site";
import { fadeUp } from "@/lib/motion";

/**
 * VisitDefinition
 * Definitive callout: what a LotWise visit actually includes. Prevents
 * the buyer's most common blocking question ("What am I actually
 * paying for?") from ever needing to be asked.
 */
export default function VisitDefinition() {
  return (
    <section
      data-testid="visit-definition"
      className="relative bg-[#F4F5F7] text-black"
    >
      <div className="container-lw section-lw">
        <div className="grid gap-14 lg:grid-cols-[1fr_1.35fr] lg:gap-24">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <div className="eyebrow text-[#4F0DFF]">
              <span className="h-1.5 w-1.5 rounded-full bg-[#4F0DFF]" />
              What a visit is
            </div>
            <h2 className="mt-5 h-display text-4xl md:text-5xl lg:text-6xl">
              {VISIT_DEFINITION.headline}
            </h2>
            <p className="mt-6 max-w-md text-[17px] leading-relaxed text-[#4A5359]">
              {VISIT_DEFINITION.intro}
            </p>
            <div className="mt-8 rounded-none border-l-2 border-[#4F0DFF] bg-white px-5 py-4 text-sm text-[#4A5359]">
              {VISIT_DEFINITION.footnote}
            </div>
          </div>

          <ol className="relative">
            {/* Vertical rule */}
            <div
              aria-hidden
              className="absolute left-[14px] top-2 h-[calc(100%-16px)] w-px bg-gradient-to-b from-black/20 via-black/10 to-transparent"
            />
            {VISIT_DEFINITION.steps.map((s, idx) => (
              <motion.li
                key={s.k}
                data-testid={`visit-step-${s.k}`}
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-80px" }}
                custom={idx}
                className="relative flex gap-8 pb-10 last:pb-0"
              >
                <div className="relative z-10 mt-1 grid h-7 w-7 shrink-0 place-items-center rounded-full bg-black text-[10px] font-semibold text-white shadow-[0_0_0_6px_#F4F5F7]">
                  {s.k}
                </div>
                <div>
                  <h3 className="font-display text-xl font-semibold tracking-tight md:text-2xl">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-[#4A5359]">
                    {s.body}
                  </p>
                </div>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
